/* eslint-disable @typescript-eslint/no-explicit-any */

export const DEFAULT_TTL = 180000

export function _getCacheKey({
  method,
  url,
  urlParams,
  fetchParams
}: {
  method: string
  url: string
  urlParams?: any
  fetchParams?: any
}) {
  return `${method}:${url}${urlParams ? `:${JSON.stringify(urlParams)}` : ''}:${fetchParams ? ':' + JSON.stringify(fetchParams) : ''}`
}
